import { Box } from '@mui/material';
import type { StyleObj } from '../../@types';
import type { CasinoJackpotIconName } from '../../constants/icons';

const ICON_SRC_BY_NAME: Record<CasinoJackpotIconName, string> = {
  diamond: '/icons/jackpot-coin-diamond.svg',
  platinum: '/icons/jackpot-coin-platinum.svg',
  gold: '/icons/jackpot-coin-gold.svg',
  silver: '/icons/jackpot-coin-silver.svg',
  bronze: '/icons/jackpot-coin-bronze.svg',
};

const styles: StyleObj = {
  icon: {
    display: 'block',
    width: '1.5rem',
    height: '1.5rem',
  },
};

type Props = {
  name: CasinoJackpotIconName;
};

const CasinoJackpotIcon = ({ name }: Props) => {
  return <Box component='img' src={ICON_SRC_BY_NAME[name]} alt={`${name} casino jackpot coin`} sx={styles.icon} />;
};

export default CasinoJackpotIcon;
